'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PagingModel2 = require('./PagingModel');

var _PagingModel3 = _interopRequireDefault(_PagingModel2);

var _Customer = require('./Customer');

var _Customer2 = _interopRequireDefault(_Customer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AccountsModel = function (_PagingModel) {
    _inherits(AccountsModel, _PagingModel);

    function AccountsModel(observers, id, request) {
        _classCallCheck(this, AccountsModel);

        var _this = _possibleConstructorReturn(this, (AccountsModel.__proto__ || Object.getPrototypeOf(AccountsModel)).call(this, observers, id, request));

        _this.Accounts = [];
        _this.DeleteAccounts = '';

        _this.Customer = new _Customer2.default();

        _this.Role = "";
        _this.UserConfig = "";
        _this.UserName = "";
        _this.RoleConfig = "";
        _this.UserId = "";

        _this.AccountResetSuccess = false;
        _this.AccountCreateSuccess = false;

        _this.CustomerNumber = "";
        _this.Email = "";
        _this.RegCode = "";
        _this.MarketingMail = false;
        _this.MarketingPost = false;
        _this.MarketingPhone = false;
        _this.FlagMarketing = false;
        _this.Iban = "";

        _this.Roles = [];
        return _this;
    }

    _createClass(AccountsModel, [{
        key: 'GetAccounts',
        value: function GetAccounts(sendData, start, limit, orderColumn, orderDirection, email, emailNew) {
            var me = this;
            var req = "/Accounts" + this.setSendData(sendData, start, limit, orderColumn, orderDirection, null, null, null, null, null, null, null, null, null, null, null, null, null, null, null, email, null, emailNew);
            this.request.setRequest(req);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        if (result.Data.Data !== undefined && result.Data.Data !== null) {
                            me.Accounts = result.Data.Data;
                        }
                    }
                }
                var id = me.Id ? me.Id : "Accounts";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'DeleteAccount',
        value: function DeleteAccount(userId) {
            var me = this;
            if (userId !== null && userId !== undefined) {
                this.request.setRequest("/AccountsDelete?userId=" + userId);
                this.request.setType('DELETE');
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            me.DeleteAccounts = result.Data;
                        }
                    }
                    var id = me.Id ? me.Id : "DeleteAccounts";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: 'Own',
        value: function Own() {
            var me = this;
            this.request.setRequest("/Accounts/own");
            this.request.setType("GET");
            if (this.request.Data !== null) {
                this.request.setData(null);
            }
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        if (result.Data[0]) {
                            me.Customer = result.Data[0];

                            localStorage.setItem("vas_customerId", result.Data[0].Id);
                            localStorage.setItem("vas_name", result.Data[0].Name1);
                            localStorage.setItem("vas_firstName", result.Data[0].Name2);
                            localStorage.setItem("vas_clientId", result.Data[0].ClientId);
                        }
                    }
                }
                var id = me.Id ? me.Id : "AccountsOwn";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'Login',
        value: function Login(login, password) {
            var me = this;
            if (login !== null && login !== undefined && password !== null && password !== undefined) {
                this.request.setRequest("/Accounts");
                this.request.setType("POST");
                this.request.setData(JSON.stringify({
                    login: login,
                    password: password
                }));
                this.request.setCallback(function (result) {
                    if (result) {
                        var tariff = localStorage.getItem('Tariff');

                        me.clearLocalStorage();

                        if (tariff !== null && tariff !== undefined) {
                            localStorage.setItem('Tariff', tariff);
                        }

                        if (result.Token) {
                            localStorage.setItem("vas_token", result.Token);
                        }
                        if (result.Role) {
                            localStorage.setItem("vas_role", result.Role);
                            me.Role = result.Role;
                        }
                        if (result.UserConfig) {
                            //localStorage.setItem('vas_config',[]);
                            localStorage.setItem('vas_config', result.UserConfig);
                            me.RoleConfig = result.RoleConfig;
                        }
                        if (result.UserName) {
                            localStorage.setItem("vas_username", result.UserName);
                            me.UserName = result.UserName;
                        }
                        if (result.RoleConfig) {
                            localStorage.setItem('vas_roleConfig', result.RoleConfig);
                            me.RoleConfig = result.RoleConfig;
                        }
                        if (result.UserId) {
                            localStorage.setItem('vas_userId', result.UserId);
                            me.UserId = result.UserId;
                        }
                    }
                    var id = me.Id ? me.Id : "Login";
                    me.Notify(id);
                });

                this.request.doRequest();
            }
        }
    }, {
        key: 'Logout',
        value: function Logout() {
            var me = this;

            this.request.setRequest("/Accounts");
            this.request.setType("DELETE");
            this.request.setErrorHandler(function () {
                me.clearLocalStorage();
            });
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data === true) {
                        me.clearLocalStorage();
                    }
                }
                var id = me.Id ? me.Id : "Logout";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'clearLocalStorage',
        value: function clearLocalStorage(excaptTariff) {
            localStorage.removeItem('vas_config');
            localStorage.removeItem('vas_token');
            localStorage.removeItem('anonymous_token');
            localStorage.removeItem('vas_role');
            localStorage.removeItem('vas_username');
            localStorage.removeItem('vas_customerId');
            localStorage.removeItem("vas_selectedTab");
            localStorage.removeItem('vas_userId');
            localStorage.removeItem('vas_roleConfig');
            if (excaptTariff !== true) {
                localStorage.removeItem("Tariff");
            }

            localStorage.removeItem('vas_name');
            localStorage.removeItem('vas_firstName');
            localStorage.removeItem('vas_clientId');

            localStorage.removeItem('NumberOfFellowPassengers');

            localStorage.removeItem('TariffProduct');
            localStorage.removeItem('TariffProducts');

            localStorage.removeItem('NumberOfFellowPassengersAdult');
            localStorage.removeItem('NumberOfFellowPassengersChild');

            localStorage.removeItem('SelectedProduct');
            localStorage.removeItem('MultimediaTexts');

            localStorage.removeItem('employee_id');
            localStorage.removeItem('employee_name1');
            localStorage.removeItem('employee_name2');

            localStorage.removeItem('ContractOverviewCustomerBirthdate');
            localStorage.removeItem('ContractOverviewCustomer');
            localStorage.removeItem('ContractOverviewCustomerPayment');
            localStorage.removeItem('ContractOverviewTariffPointFrom');
            localStorage.removeItem('ContractOverviewTariffPointTo');
            localStorage.removeItem('ContractOverviewTariffProduct');
            localStorage.removeItem('ContractOverviewContractStart');
            localStorage.removeItem('ContractOverviewContractEnd');
            localStorage.removeItem('AccountOwner');
            localStorage.removeItem('AccountOwnerBirthDate');
            localStorage.removeItem('LegalGuardian');
            localStorage.removeItem('LegalGuardianBirthDate');

            localStorage.removeItem('MultimediaTextProduct');

            localStorage.removeItem('ContractOverviewTariffPointFromAtg');
            localStorage.removeItem('ContractOverviewTariffPointToAtg');
        }
    }, {
        key: 'AccountReset',
        value: function AccountReset(email) {
            var me = this;
            if (email !== null && email !== undefined) {
                this.request.setRequest("/AccountsReset?email=" + email);
                this.request.setType('GET');
                this.request.setCallback(function (result) {
                    if (result) {
                        if (result.Data) {
                            if (result.Data.ValidSyntax === true && result.Data.AccountExists === true) {
                                me.AccountResetSuccess = true;
                            } else {
                                me.AccountResetSuccess = false;
                            }
                        }
                    }
                    var id = me.Id ? me.Id : "ResetAccounts";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: 'AccountCreate',
        value: function AccountCreate(SchoolId) {
            if (SchoolId !== null && SchoolId !== undefined) {
                var sendData = {};
                sendData.SchoolId = SchoolId;
                sendData.Customer = this.Customer;

                var me = this;

                this.request.setRequest("/AccountsCreate");
                this.request.setData(JSON.stringify(sendData));
                this.request.setType("POST");
                this.request.setCallback(function (result) {
                    me.AccountCreateSuccess = true;
                    var id = me.Id ? me.Id : "AccountCreate";
                    me.Notify(id);
                });
                this.request.doRequest();
            }
        }
    }, {
        key: 'AccountCreateConsistedCustomer',
        value: function AccountCreateConsistedCustomer() {

            var sendData = {};
            sendData.CustomerNumber = this.CustomerNumber;
            sendData.Email = this.Email;
            sendData.RegCode = this.RegCode;
            sendData.MarketingMail = this.MarketingMail;
            sendData.MarketingPost = this.MarketingPost;
            sendData.MarketingPhone = this.MarketingPhone;
            sendData.FlagMarketing = this.FlagMarketing;
            sendData.IbanCheck = this.Iban;
            sendData.Phone = this.Phone;

            var me = this;

            this.request.setRequest("/AccountsCreate/ConsistedCustomer");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                me.AccountCreateSuccess = true;
                var id = me.Id ? me.Id : "AccountCreateConsistedCustomer";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'DeleteAccountOwn',
        value: function DeleteAccountOwn() {
            var me = this;

            this.request.setRequest("/AccountsDelete/Own");
            this.request.setType('DELETE');
            this.request.setCallback(function (result) {
                if (result) {
                    if (result.Data) {
                        me.DeleteAccounts = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "DeleteAccountsOwn";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }, {
        key: 'GetRoles',
        value: function GetRoles() {
            var me = this;
            var req = "/Roles";
            this.request.setRequest(req);
            this.request.setType("GET");
            this.request.setCallback(function (result) {
                if (result) {
                    me.setResult(result);
                    if (result.Data) {
                        me.Roles = result.Data;
                    }
                }
                var id = me.Id ? me.Id : "Roles";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'AccountCreateFKV',
        value: function AccountCreateFKV(roleId) {

            var sendData = {};
            sendData.CustomerNumber = this.CustomerNumber;
            sendData.Email = this.Email;
            sendData.RegCode = this.RegCode;
            sendData.MarketingMail = this.MarketingMail;
            sendData.MarketingPost = this.MarketingPost;
            sendData.MarketingPhone = this.MarketingPhone;
            sendData.FlagMarketing = this.FlagMarketing;
            sendData.IbanCheck = this.Iban;

            var me = this;

            this.request.setRequest("/Roles/" + roleId + "/AccountsCreate/ConsistedCustomer");
            this.request.setData(JSON.stringify(sendData));
            this.request.setType("POST");
            this.request.setCallback(function (result) {
                me.AccountCreateSuccess = true;
                var id = me.Id ? me.Id : "AccountCreateFKV";
                me.Notify(id);
            });

            this.request.doRequest();
        }
    }, {
        key: 'Aktivate',
        value: function Aktivate() {
            var me = this;

            this.request.setRequest("/Accounts/activate");
            this.request.setType('GET');
            this.request.setCallback(function (result) {

                var id = me.Id ? me.Id : "AccountsActivate";
                me.Notify(id);
            });
            this.request.doRequest();
        }
    }]);

    return AccountsModel;
}(_PagingModel3.default);

exports.default = AccountsModel;